"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

//# sourceMappingURL=android.color.types.js.map
